import React, { useState } from "react";
import { X, Copy, Search, CheckCircle, XCircle, AlertCircle } from "lucide-react";

const SearchResultsPopup = ({ results, onClose }) => {
  const [notification, setNotification] = useState("");

  const handleCopyToClipboard = (agentID) => {
    navigator.clipboard.writeText(agentID);
    setNotification(`تم نسخ المعرف: ${agentID}`);
    
    setTimeout(() => {
      setNotification("");
    }, 2000);
  };

  return (
    <div className="fixed inset-0 backdrop-blur-md bg-black/70 z-[150000] flex items-center justify-center p-4">
      {/* Notification */}
      {notification && (
        <div className="fixed top-4 left-1/2 transform -translate-x-1/2 bg-gray-900/90 text-white py-3 px-6 rounded-xl shadow-lg transition-all duration-300 border border-gray-700/50 backdrop-blur-sm flex items-center gap-2">
          <Copy className="w-4 h-4 text-[#FEC111]" />
          {notification}
        </div>
      )}

      <div className="bg-gradient-to-b bg-gray-900 w-full max-w-2xl rounded-2xl shadow-2xl overflow-hidden border border-gray-800/50" dir="rtl">
        {/* Header */}
        <div className="sticky top-0 bg-gray-900/95 backdrop-blur border-b border-gray-800/50 p-6">
          <div className="flex justify-between items-center">
            <h2 className="text-xl font-bold text-white flex items-center gap-3">
              <Search className="w-6 h-6 text-[#FEC111]" />
              <span className="bg-gradient-to-r from-white to-gray-300 bg-clip-text text-transparent">
                نتائج البحث
              </span>
            </h2>
            <button
              onClick={onClose}
              className="text-gray-400 w-10 h-10 rounded-full flex items-center justify-center bg-gray-800/50 hover:bg-[#FEC111] hover:text-black transition-all duration-300 hover:scale-105"
            >
              <X className="w-5 h-5" />
            </button>
          </div>
        </div>

        <div className="max-h-[60vh] overflow-y-auto">
          <div className="p-6">
            {!results || results.length === 0 ? (
              <div className="text-center py-12">
                <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-gray-800/50 mb-4">
                  <AlertCircle className="w-8 h-8 text-gray-400" />
                </div>
                <p className="text-gray-400 mb-6">لم يتم العثور على نتائج</p>
                <button
                  onClick={onClose}
                  className="px-6 py-3 bg-[#FEC111] text-black rounded-xl hover:bg-[#FEC111]/90 transition-all duration-300 font-bold inline-flex items-center gap-2"
                >
                  <X className="w-5 h-5" />
                  إغلاق
                </button>
              </div>
            ) : (
              <div className="space-y-3">
                {results.map((result) => (
                  <div
                    key={result.id}
                    onClick={() => handleCopyToClipboard(result.id)}
                    className={`group p-4 rounded-xl border transition-all duration-300 cursor-pointer hover:scale-[1.02] ${
                      result.available 
                        ? 'bg-emerald-500/10 border-emerald-500/20 hover:border-emerald-500/40' 
                        : 'bg-rose-500/10 border-rose-500/20 hover:border-rose-500/40'
                    }`}
                  >
                    <div className="flex flex-col sm:flex-row items-start sm:items-center gap-4">
                      <div className="flex items-center gap-2 text-white font-medium">
                        {result.available ? (
                          <CheckCircle className="w-5 h-5 text-emerald-400" />
                        ) : (
                          <XCircle className="w-5 h-5 text-rose-400" />
                        )}
                        {result.name}
                      </div>
                      
                      <div className="flex-1 text-gray-400 text-sm">
                        {result.id}
                      </div>
                      
                      <div className="flex items-center gap-3 text-gray-400">
                        <span>{result.product_type}</span>
                        <div className="w-8 h-8 rounded-lg bg-gray-800/50 flex items-center justify-center group-hover:bg-[#FEC111] group-hover:text-black transition-colors duration-300">
                          <Copy className="w-4 h-4" />
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchResultsPopup;